//MODEL: custom model object : { domain: instance of Domain }

define('app/editor/dialogs/SelectColumnsDialogView',['require','glu/itemView','glu/collection','app/filters/FieldFilterView','app/models/FieldFilter','app/models/Field','app/app','glu/util','glu/$','hbs!./SelectColumnsDialogView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		Collection = require('glu/collection'),
		FieldFilterView = require('app/filters/FieldFilterView'),
		FieldFilter = require('app/models/FieldFilter'),
		Field = require('app/models/Field'),
		App = require('app/app'),
		_ = require('glu/util'),
		$ = require('glu/$');

	var view = ItemView.extend({

		template: require('hbs!./SelectColumnsDialogView.hbs'),

		ui: {
			$searchTxt: '[name=searchTxt]'
		},

		events: {
			'submit form': 'submitForm',
			'keyup .virtual-column-name>input': 'validateColumnName',
			'keyup [name="searchTxt"]': 'updateView',
			'click [type="checkbox"]': 'toggleFilterOptions',
			'change [name="value"]': 'updateModel',
			'change [name="content-mode"]': 'updateContentView',
			'click tr.child-columns-message a': 'showChildFields'
		},

		dialogTitle: 'Select Columns',

		getClass: function() {
			return this.className || 'modal-select-columns';
		},

		dialogButtons: [{
			text: 'Add Columns',
			callback: 'announceSelectedFields',
			className: 'btn-primary'
		}],

		initialize: function() {
			if (this.options) {
				this.dialogTitle = this.options.dialogTitle || this.dialogTitle;
				this.dialogButtons = this.options.dialogButtons || this.dialogButtons;
				this.viewMode = this.options.viewMode || this.viewMode;
				this.className = this.options.className || this.className;
				this.modalClass = this.options.modalClass || this.modalClass;
			}
			this.tempFilters = new Collection();
			this.nonFieldFilters = new Collection();

			this.setTimespanOptions();

			if (this.model.get('domain') && this.model.get('domain').getTimespanOptions) {
				this.timespanOptions = this.model.get('domain').getTimespanOptions();
			}
		},

		hasSegments: function() {
			return this.model.get('segments') && this.model.get('segments').length > 0;
		},

		segments: function() {
			return this.model.get('segments');
		},

		updateContentView: function() {
			if (this.$el.find('[name="content-mode"][value="filters"]').prop('checked') === true) {
				this.$el.find('.select-segments-content').hide();
				this.$el.find('.select-columns-content').show();
				$('.modal-select-filters .btn-filters').removeClass('hidden');
				$('.modal-select-filters .btn-segments').addClass('hidden');
			} else if (this.$el.find('[name="content-mode"][value="segments"]').prop('checked') === true) {
				this.$el.find('.select-columns-content').hide();
				this.$el.find('.select-segments-content').show();
				$('.modal-select-filters .btn-filters').addClass('hidden');
				$('.modal-select-filters .btn-segments').removeClass('hidden');
			}
		},

		setTimespanOptions: function() {

		},

		onRender: function() {
			var self = this;

			this.$el.find('[name="content-mode"][value="filters"]').prop('checked', true);
			this.updateContentView();

			setTimeout(function() {
				self.$('.search-column-name').width(self.$el.width() - 10);
			}, 0);
		},

		submitForm: function(e) {
			e.preventDefault();
			$(e.target).find('input[name="searchTxt"]').blur();
		},

		showChildFields: function(e) {
			var id = e.view.$(e.target).closest('tr').data('parent-field-id');
			e.view.$('.child-columns[data-parent-field-id="' + id + '"]').show();
			e.view.$(e.target).closest('tr').hide();
		},

		topFields: function() {
			var self = this;
			var domain = this.model.get('domain');
			var report = this.model.get('report');
			var output = [];

			_.each(this.model.get('topFieldIds'), function(id) {
				var field = domain.getFieldObjectById(id);
				if (field) {
					output.push({
						id: field.id,
						displayName: field.displayName(),
						description: field.description(),
						isFilters: self.options.viewMode && self.options.viewMode === 'filters',
						title: field.qualifiedName()
					});
				} else {
					// segment?
					var segment = App.segments.get(id);
					if (segment) {
						output.push({
							id: segment.id,
							segmentid: segment.id,
							displayName: segment.getName(),
							description: segment.getDescription(),
							isFilters: self.options.viewMode && self.options.viewMode === 'filters',
							title: segment.getName()
						});
						var segfilter = report.getFieldEqualsValueSegmentFilter(segment);
						segfilter.segmentid = segment.id;
						self.nonFieldFilters.add(segfilter);
					} else {
						// virtual column?
						var virtual = report.getColumnByName(id);
						if (virtual) {
							output.push({
								id: virtual.get('name'),
								displayName: virtual.get('name'),
								description: virtual.get('description'),
								isFilters: self.options.viewMode && self.options.viewMode === 'filters',
								title: virtual.get('name')
							});
							var virtualfilter = report.getFieldEqualsValueFunctionFilter(virtual);
							virtualfilter.virtualColName = virtual.get('name');
							self.nonFieldFilters.add(virtualfilter);
						}
					}
				}
			});

			return output;
		},

		hasTopFields: function() {
			var topFieldIds = this.model.get('topFieldIds');
			return !!topFieldIds && topFieldIds.length > 0;
		},

		isFilters: function() {
			return this.options.viewMode && this.options.viewMode === 'filters';
		},

		isVirtualColumn: function(e) {
			return $(e.target).parent().parent().hasClass('virtual-column');
		},

		tables: function() {
			var self = this;
			var tables = _.map(this.model.get('domain').getTables(self.isFilters()), function(o, k) {
				var fields = _.map(o, function(field) {
					var fieldView, fieldFilter;

					if (!field.funcArguments) {
						fieldFilter = new FieldFilter({
							fieldObject: new Field(field),
							operator: 'EQ'
						});
						fieldView = new FieldFilterView({
							model: fieldFilter
						});
					}

					return {
						displayName: field.asName || field.name,
						id: field.id,
						isHidden: !!field.isHidden,
						description: field.description,
						isVirtualColumn: !!field.dbFunction,
						virtualColumnArguments: field.funcArguments,
						timespanOptions: self.timespanOptions,
						hasTimespanOptions: self.timespanOptions && self.timespanOptions.length > 1,
						hasChildFields: !!field.childFields && field.childFields.length > 0,
						isFilters: self.options.viewMode && self.options.viewMode === 'filters',
						showChildFieldsLabel: field.showChildFieldsLabel,
						fieldView: fieldView,
						childFields: _.map(field.childFields, function(childField) {
							return {
								displayName: childField.asName || childField.name,
								id: childField.id,
								isHidden: !!childField.isHidden,
								isFilters: self.options.viewMode && self.options.viewMode === 'filters',
								description: childField.description
							};
						})
					};
				});

				return {
					displayName: k,
					fields: fields
				};
			});

			return _.filter(tables, function(table) {
				return table.fields.length > 0;
			});


		},

		getCheckboxForFieldById: function(id) {
			return this.$el.find('input[type="checkbox"][data-field-id="' + id + '"]');
		},

		announceSelectedSegment: function() {
			var ids = this.$el.find('.select-segments-content input[type="checkbox"]:checked').map(function(i, el) {
				return el.getAttribute('data-field-id');
			}).toArray();

			this.trigger('selectSegment', ids);
		},

		announceSelectedFields: function() {
			var self = this,
				ids = this.$el.find('input[type="checkbox"]:checked').not($('input.virtual-column')).not('input.segment').map(function(i, el) {
					return el.getAttribute('data-field-id');
				}).toArray(),
				virtualColumns = [],
				virtualColumnIds = this.$el.find('input.virtual-column:checked').map(function(i, el) {
					return el.getAttribute('data-field-id');
				}).toArray(),
				segmentIds = this.$el.find('.select-segments-content input[type="checkbox"]:checked').map(function(i, el) {
					return el.getAttribute('data-field-id');
				}).toArray();

			// Get virtual columns
			if (virtualColumnIds.length > 0) {
				for (var i = 0; i < virtualColumnIds.length; i++) {
					var fnCol = _.find(self.model.get('domain').get('functions'), function(fn) {
							return virtualColumnIds.indexOf(fn.name) !== -1;
						}),
						args = [];

					var vColumn = $('#' + virtualColumnIds[i] + '-virtual-column-name');
					var vColumnName = vColumn.val();
					if (!vColumnName || this.isDuplicateVirtualName(self.model.get('report'), vColumnName)) {
						self.setValidationError(vColumn);
						vColumn.focus();
						return;
					}
					for (var j = 0; j < fnCol.arguments.length; j++) {
						args.push({
							name: $('#' + virtualColumnIds[i] + '-' + fnCol.arguments[j].name).children(':selected').text(),
							fieldId: $('#' + virtualColumnIds[i] + '-' + fnCol.arguments[j].name).val()
						});
					}

					virtualColumns.push({
						columnType: 'FUNCTION',
						function: virtualColumnIds[i],
						displayName: vColumnName || fnCol.displayName,
						name: vColumnName || fnCol.displayName,
						funcArguments: args,
						type: fnCol.type
					});
				}
			}

			if (self.isFilters()) {
				_.each(ids, function(id, index) {
					ids[index] = self.getFieldFilter(id);
				});
			}

			this.trigger('selectFields', ids, virtualColumns, segmentIds);
		},

		setValidationError: function(column) {
			column.parent().addClass('has-error');
			column.parent().find('span.help-block').text('The name should be unique and non-empty');
		},

		unsetValidationError: function(column) {
			column.parent().removeClass('has-error');
			column.parent().find('span.help-block').text('');
		},

		isDuplicateVirtualName: function(report, columnname) {
			var isDuplicate = false;
			report.eachVisibleColumn(
				function(c) {
					if (c.get('name') === columnname) {
						isDuplicate = true;
					}
				}
			);
			return isDuplicate;
		},

		validateColumnName: function(el) {
			var textbox = $(el.target);
			if (textbox && textbox.val() && !this.isDuplicateVirtualName(this.model.get('report'), textbox.val())) {
				this.unsetValidationError(textbox);
			} else {
				this.setValidationError(textbox);
			}
		},

		cancel: function() {
			this.trigger('closeModal');
		},

		serializeData: function() {
			return this;
		},

		toggleFilterOptions: function(e) {
			var self = this,
				id = $(e.currentTarget).data('fieldId');

			if (this.isFilters()) {
				var fieldFilter,
					fieldView,
					isViewAdded = $(e.target).parents('tr.parent').next('.filter-options').find('.edit-filter').length > 0;

				if (!isViewAdded) {
					fieldFilter = self.getFieldFilter(id);
					if (fieldFilter) {
						fieldView = new FieldFilterView({
							model: fieldFilter
						});
					}

					if (fieldView) {
						$(e.target).parents('tr.parent').next('.filter-options').find('.filter-content').html(fieldView.render().$el);
					}
				}

				if (e && this.isFilters()) {
					if ($(e.target).is(':checked')) {
						$(e.target).parents('tr.parent').addClass('active');
						$(e.target).parents('tr.parent').next('.filter-options').addClass('active');
						$('#modal-body').animate({
							scrollTop: $('#modal-body').scrollTop() + $(e.target).position().top - 90
						}, 250);

					} else {
						$(e.target).parents('tr.parent').removeClass('active');
						$(e.target).parents('tr.parent').next('.filter-options').removeClass('active');
					}
				}
			} else if (this.isVirtualColumn(e)) {
				if ($(e.target).is(':checked')) {
					$(e.target).parents('tr.parent').addClass('active');
					$(e.target).parents('tr.parent').next('.filter-options').addClass('active');
					$('#modal-body').animate({
						scrollTop: $('#modal-body').scrollTop() + $(e.target).position().top - 90
					}, 250);

					// Set default values
					_.each($(e.target).parents('tr.parent').next('.filter-options').find('select'), function(select, index) {
						$(select).find('option:eq(' + index + ')').prop('selected', true);
					});
				} else {
					$(e.target).parents('tr.parent').removeClass('active');
					$(e.target).parents('tr.parent').next('.filter-options').removeClass('active');
				}
			}
		},

		getFieldFilter: function(id) {
			var filters = this.tempFilters;
			var output = '';

			// Search for existing filter in collection
			if (filters.length > 0) {
				filters.each(function(filter) {
					if (filter.attributes.fieldObject.id === id) {
						output = filter;
					}
				});
			} else {
				var extraFilters = this.nonFieldFilters;
				if (extraFilters.length > 0) {
					extraFilters.each(function(filter) {
						if (filter.segmentid && filter.segmentid === id) {
							output = filter;
						} else if (filter.virtualColName && filter.virtualColName === id) {
							output = filter;
						}
					});
				}
			}

			// Add new filter if it doesn't exist
			if (!output) {
				_.each(this.model.get('domain').getTables(), function(section) {
					_.each(section, function(field) {
						if (field.childFields) {
							_.each(field.childFields, function(childField) {
								if (childField.id === id) {
									output = new FieldFilter({
										fieldObject: new Field(childField),
										operator: 'EQ',
										doFetchConstraintsOnInit: true
									});
									return false;
								}
							});
						}

						if (field.id === id) {
							output = new FieldFilter({
								fieldObject: new Field(field),
								operator: 'EQ',
								doFetchConstraintsOnInit: true
							});
							return false;
						}
					});
				});

				filters.add(output);
			}

			return output;
		},

		updateView: function() {
			var self = this;
			var searchTxt = this.ui.$searchTxt.val();
			var $tables = this.$el.find('table');
			var $rows = this.$el.find('tr.parent, tr.child-columns');
			var $children = self.$el.find('tr.child-columns');
			var $showMessages = self.$el.find('tr.child-columns-message');

			if (searchTxt) {
				$children.show();

				// hide all the fields that does not include the searchTxt in it
				for (var i = 0; i < $rows.length; i++) {
					var containsText = $($rows[i]).text().toLowerCase().indexOf(searchTxt.toLowerCase()) !== -1;

					$($rows[i]).show();
					$($rows[i]).removeClass('hidden');

					if (!containsText) {
						if (!$($rows[i]).hasClass('active') && $($rows[i]).find('input:checked').length === 0) {
							$($rows[i]).addClass('hidden');
							$($rows[i]).hide();
						}
					} else {
						$($rows[i]).prevUntil('tr.parent').prev('tr.parent').show();
						$($rows[i]).prevUntil('tr.parent').prev('tr.parent').removeClass('hidden');
					}
				}

				window.setTimeout(function() {
					$.each($tables, function(index, val) {
						if ($(val).find('> tbody').children().length === $(val).find('> tbody').children('.hidden').length) {
							$(val).parent().hide();
						} else {
							$(val).parent().show();
						}
					});
				}, 0);

				$showMessages.hide();
			} else {
				$tables.parent().show();
				$rows.show();
				$rows.removeClass('hidden');
				$children.hide();
				$showMessages.show();
			}
		}
	});

	return view;
});

